import React from 'react';
import { useNavigate } from 'react-router-dom';

const OpeningHours = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  const rows = [
    { day: 'Montag', time: 'Geschlossen' },
            { day: 'Dienstag', time: '11:00–14:00, 17:00–22:00' },
            { day: 'Mittwoch', time: '11:00–14:00, 17:00–22:00' },
            { day: 'Donnerstag', time: '11:00–14:00, 17:00–22:00' },
            { day: 'Freitag', time: '11:00–14:00, 17:00–22:00' },
            { day: 'Samstag', time: '11:00–14:00, 17:00–22:00' },
            { day: 'Sonntag', time: '11:00–14:00, 17:00–22:00' },
  ];

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        backgroundColor:" #fcf9ef", // beige background
        color: '#fff',
        fontFamily: 'Open Sans, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '100px',
        zIndex: 1000,
      }}
    >
      <button
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: '20px',
          right: '30px',
          fontSize: '28px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#e80000',
        }}
        aria-label="Close"
      >
        &times;
      </button>

      <h1
        style={{
          fontSize: '36px',
          marginBottom: '40px',
          color: '#e80000',
          fontWeight: '400',
        }}
      >
       Öffnungszeiten
      </h1>

      <table
        style={{
          width: '90%',
          maxWidth: '700px',
          fontSize: '18px',
          borderCollapse: 'collapse',
          backgroundColor: 'transparent',
          color: '#e80000',
        }}
      >
        <tbody>
          {rows.map(({ day, time }, idx) => (
            <tr key={day}>
              <td
                style={{
                  padding: '16px',
                  textAlign: 'center',
                  border: '1px solid rgba(150, 118, 118, 0.3)',
                  fontWeight: '400',
                  fontSize: '18px',
                  width: '50%',
                }}
              >
                {day}
              </td>
              <td
                style={{
                  padding: '16px',
                  textAlign: 'center',
                  border: '1px solid rgba(181, 24, 24, 0.3)',
                  fontSize: '18px',
                  fontWeight: '400',
                  color:"#e80000",
                  fontStyle: time === 'Closed' ? 'italic' : 'normal',
                }}
              >
                {time}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OpeningHours;
